import { __assign } from "tslib";
import React, { useMemo } from 'react';
import { getWeek } from 'web-platform-alpha/libs/date';
import { useCalendar, useFirstDayOfWeek } from 'web-platform-alpha';
import { cnCalendar } from '../Calendar.const';
import { DateCell } from '../DateCell';
import { DaysOfWeek } from '../DaysOfWeek';
import { Navigation } from '../Navigation';
import { Grid, GridCell, GridRow, GridSection } from '../shared';
import './View.css';
export var View = function (props) {
    var _a = props.showDaysOfWeek, showDaysOfWeek = _a === void 0 ? true : _a, showOutsideDays = props.showOutsideDays, showWeekNumbers = props.showWeekNumbers, showQuarters = props.showQuarters, viewDate = props.viewDate, viewRange = props.viewRange, data = props.data, state = props.state, index = props.index, _b = props.viewsCount, viewsCount = _b === void 0 ? 1 : _b, renderCell = props.renderCell;
    var activeView = state.activeView;
    var gridProps = useCalendar(props, state).gridProps;
    var localeFirstDayOfWeek = useFirstDayOfWeek();
    var firstDayOfWeek = props.firstDayOfWeek !== undefined ? props.firstDayOfWeek : localeFirstDayOfWeek;
    var asideData = useMemo(function () { return getAsideData(activeView, data, firstDayOfWeek); }, [activeView, data, firstDayOfWeek]);
    var showAside = (activeView === 'day' && showWeekNumbers) || (activeView === 'month' && showQuarters);
    return (React.createElement("div", { className: cnCalendar('View', { type: activeView }) },
        React.createElement("div", { className: cnCalendar('Header') },
            React.createElement(Navigation, { state: state, viewRange: viewRange, prevHidden: index > 0, nextHidden: index < viewsCount - 1 }),
            showDaysOfWeek && activeView === 'day' && (React.createElement(DaysOfWeek, { showWeekNumbers: showWeekNumbers, daysOfWeek: data[0] }))),
        React.createElement("div", { className: cnCalendar('Body') },
            React.createElement(Grid, __assign({}, gridProps),
                showAside && (React.createElement(GridSection, { type: "aside" }, asideData.map(function (value, rowIndex) { return (React.createElement(GridRow, { key: rowIndex },
                    React.createElement(GridCell, null, value))); }))),
                React.createElement(GridSection, { type: "body" }, data.map(function (row, rowIndex) { return (React.createElement(GridRow, { key: rowIndex, role: "row" }, row.map(function (value, cellIndex) { return (React.createElement(DateCell, { key: rowIndex + "-" + cellIndex, state: state, value: value, viewDate: viewDate, showOutsideDays: showOutsideDays, renderCell: renderCell })); }))); }))))));
};
if (process.env.NODE_ENV !== 'production') {
    View.displayName = 'View';
}
var QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4'];
function getAsideData(view, data, firstDayOfWeek) {
    if (view === 'month') {
        return QUARTERS;
    }
    if (view === 'day') {
        return data.map(function (row) { return getWeek(row[0], { weekStartsOn: firstDayOfWeek }); });
    }
    return [];
}
